import { MailMessagesList } from "../../../../MailMessages"
import { useTripDetailsOutletContext } from "./_trip-details-context"
import { Helmet } from "react-helmet-async"

export default function TripEmailsPage() {
	const { trip, onChange } = useTripDetailsOutletContext()
	return (
		<>
			<Helmet>
				<title>Emails | Trip</title>
			</Helmet>
			<MailMessagesList
				modelType="trips"
				modelId={Number(trip.id)}
				title="Emails"
				emptyStateMessage="No email messages are linked to this trip yet."
				onChange={onChange}
				syncQueryToUrl
			/>
		</>
	)
}
